// extracted by mini-css-extract-plugin
module.exports = {"root":"TopicSectionPreview_root__2Jwke"};